export default "<app-nav></app-nav>\n<app-header></app-header>\n<router-outlet></router-outlet>\n<app-footer></app-footer>"